import ToggleSwitch from 'common/components/base/toggle-switch';

import './ToggleSwitchCellRenderer.scss';
import { Action } from 'common/enums';
import { IsEYPresence } from 'modules/data-management/enums/data-management.enum';
import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
type ToggleSwitchCellRendererProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any;
    rowIndex: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAction: (action: Action, data: any, api: GridApi) => void;
    api: GridApi;
    isActionDisabled: boolean;
};

export default function ToggleSwitchCellRenderer({
    data,
    rowIndex,
    onAction,
    api,
    isActionDisabled
}: ToggleSwitchCellRendererProps) {
    return (
        <div className="header-right">
            <ToggleSwitch
                id={'toggleId' + rowIndex}
                className={isActionDisabled ? 'toggle-switch-disabled' : 'toggle-switch'}
                onLabel={IsEYPresence.onLabel}
                offLabel={IsEYPresence.offLabel}
                checked={data.isEYPresence}
                onChange={() => {
                    onAction(Action.ToggleCompanyPresence, data, api);
                }}
                disableButton={isActionDisabled}
            />
        </div>
    );
}
